import h from "../../../../core/createElement";
import _ from "lodash";
import BorderBox from "../../../../components/borderbox";
import Input from "../../../../components/input";

const default_database = {
    "dialect": null,
    "host": null,
    "dbname": null,
    "username": null,
    "password": null,
    "ssl": false,
    "encrypt": false,
    "app_name": null
};

export default function DbConnectionPart({ shared = {}, onChangeObject, name = "dbform" }) {
    const
        inner_shared = {},
        dialects = [
            { label: "Postgres", value: "postgres" },
            { label: "Sql Server", value: "sqlserver" },
            { label: "My Sql", value: "mysql" }
        ],
        database = { ...default_database };

    const
        upt_object_value = () => {
            onChangeObject && onChangeObject(database);
        },
        transformValue = (value, default_transform) => value == "" ? null : default_transform()

    shared[name] = {
        patch_values_object: (object) => {
            for (let i in object) {
                if (inner_shared.hasOwnProperty(i) && object[i] != undefined) inner_shared[i].value = object[i];
                else inner_shared[i].value = null;
            };

            return database;
        },
        get_object: () => database,
        get_default: () => default_database
    };

    return (
        <BorderBox title="Conexão com banco de dados" contentClass="flex-column" containerClass="flex-1">
            <Input shared={inner_shared} bindObject={database} transformValue={transformValue} title="Dialeto *" name="dialect" type="select" items={dialects} onChange={upt_object_value} />
            <Input shared={inner_shared} bindObject={database} transformValue={transformValue} title="Host *" name="host" onKeyup={upt_object_value} />
            <Input shared={inner_shared} bindObject={database} transformValue={transformValue} title="Nome *" name="dbname" onKeyup={upt_object_value} />
            <Input shared={inner_shared} bindObject={database} transformValue={transformValue} title="Usuário *" name="username" onKeyup={upt_object_value} />
            <Input shared={inner_shared} bindObject={database} transformValue={transformValue} title="Senha *" name="password" onKeyup={upt_object_value} />
            <Input shared={inner_shared} bindObject={database} type="boolean-select" title="SSL" name="ssl" onChange={upt_object_value} />
            <Input shared={inner_shared} bindObject={database} type="boolean-select" title="Encrypt" name="encrypt" onChange={upt_object_value} />
            <Input shared={inner_shared} bindObject={database} transformValue={transformValue} title="App Name" name="app_name" onKeyup={upt_object_value} />
        </BorderBox>
    );
}